import React, {Component} from 'react';
// import {} from 'react-router-dom';
import './App.css';
import MediaSlider from './Components/MediaSlider/MediaSlider';
import Radio from './Components/Forms/Radio';
import Range from './Components/Forms/Range';
// import UserSignIn from './Components/Forms/UserSignIn';
import Search from './Components/Forms/Search';
// Each backend call now hits its own Ray Serve endpoint path under the `default`
// codops gateway, rather than one REST base + relative routes.
const localDev = false;
const ENDPOINTS_BASE_URL = localDev ? "//localhost:8000" : "https://api.default.peach.ebu.io/v2";
const ENDPOINTS = {
	popular: ENDPOINTS_BASE_URL + '/moviesdemo-popular',
	movieInfo: ENDPOINTS_BASE_URL + '/moviesdemo-movie-info',
	similarMovies: ENDPOINTS_BASE_URL + '/moviesdemo-similar-movies',
	search: ENDPOINTS_BASE_URL + '/moviesdemo-search',
	filterByGenre: ENDPOINTS_BASE_URL + '/moviesdemo-filter-by-genre',
};

// ============================================================================   
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
				message:'',
				mainLaneElements : [],
				populareElements :  [],
				historyElements : [],
				diversityToggle: true,
				slideToIndex: 0,
				popularQuery: '',
				popularQueryPerformance: 0,
				shouldPopularSwiperResetState: false,
				showAdv: false,
				selectedRecommendation: 'basic',
				decayAlpha: 0.7,
				signinname: 'Joker',
				issignin: false,
				showInfo: false
    };
  }
  
  elementsToLoad() {
	  return 35;
  }

	toggleDiversity(show){
		var showInfo = this.state.showInfo ? 'block' : 'none';
		var showRange = (this.state.selectedRecommendation === 'decay') ? <Range updateRange={(value) => {this.setState(Object.assign(this.state, {decayAlpha: value}))}} updateSelection={() => {this.selectedPopular()}} range={this.state.decayAlpha} /> : '';
		if(show)
			return (
				<small className="recommend-buttons">
					<Radio label="Basic" updateState={(recType) => {this.updateDiversityToggle(recType)}} selectedoption={this.state.selectedRecommendation} name="recommendgroup"/>
					<Radio label="Diversity" updateState={(recType) => {this.updateDiversityToggle(recType)}} selectedoption={this.state.selectedRecommendation} name="recommendgroup"/>
					<Radio label="Mean" updateState={(recType) => {this.updateDiversityToggle(recType)}} selectedoption={this.state.selectedRecommendation} name="recommendgroup"/>
					<Radio label="Decay" updateState={(recType) => {this.updateDiversityToggle(recType)}} selectedoption={this.state.selectedRecommendation} name="recommendgroup"/>
					<sup className="info" onClick={() => this.showInfo()}>i</sup>	
					{showRange}
					<div className="popup" style={{display: showInfo}} onClick={() => this.showInfo()}>
						<div className="info-text popup-inner" >
						<sup className="info" style={{color:'#fff'}}>i</sup>
						<h5>Basic</h5>
						<div>Computes separately similar movies for each movie in history, merges the lists and sorts globally by score.
							A simple change would be to sum up these scores.
							 Thus it can easily go above 100%.
							Which, in a way, can also be interpreted as "we are really sure that user will like this, as more than 1 movie watched are similar to this one"</div>
						<h5>Diversity</h5>
						<div>Computes separately similar movies for each movie in history. Take first recommendation for each item in user history, and then add other recommendation sorted by score. Duplicates are removed.</div>
						<h5>Mean</h5>
						<div>Gets vector representation of each movie in the history (precomputed). Stacks them on top of each other and computes a mean. Then looking up the most similar vectors to a calculated vector in the database. This approach shows that you can combine the vectors results to retrieve recommendations with a single request and without sorting and filtering multiple lists.</div>
						</div>
					</div>
				</small>
			);
		return (<small/>);
	}

	showInfo() {
		this.setState(Object.assign(this.state, {showInfo: !this.state.showInfo}))
	}		
// <UserSignIn issignin={this.state.issignin} signinname={this.state.signinname}></UserSignIn>
  render() {
    return (
        <div className="App">
					<article>
						<section>
						<h1 className="page-title">A DEMO OF MOVIE RECOMMENDATIONS</h1>
						</section>
						<hr/>
					<section className="mainarea popular" style={{minHeight:'170px'}}>
						<Search showAdv={this.state.showAdv} onShowAdv={(show) => this.showAdv(show)} query={this.state.popularQuery} onSearch={(query, queryType, flags) => this.searchPopular(query, queryType,flags)}/>
						<MediaSlider style={{clear:'both'}} ref={popSlider => this.popSlider = popSlider} header="Popular movies" 
							slideTo={this.state.slideToIndex} 
							selection="popular" 
							elements={this.state.populareElements} 
							onElementClick={(item)=>{this.selectedPopular(item.id, true)}}
							shouldSwiperResetState={this.state.shouldPopularSwiperResetState}
							query={this.state.popularQuery}
							queryTime={this.state.popularQueryPerformance}
							/>
					</section>
					<hr />
					<section className="mainarea recommendation">
					<h4 style={{
							"textAlign":"left", 
							"marginBottom":"-20px"}}>
								Recommendations
								{this.toggleDiversity(true)}
						</h4>
						<MediaSlider header="Recommendation"
						 slideTo={this.state.slideToIndex} 
						 selection="recommend" elements={this.state.mainLaneElements} onElementClick={(item)=>{this.selectedPopular(item.id, true)}}/>
					</section>
					<hr/>
					<section className="mainarea selection">
						<div onClick={() => this.removeUserHistory()} className="smallblackarea" style={{position: "initial",
    float:"right"}}>Remove All</div>
					<h4 style={{
							"textAlign":"left", 
							"marginBottom":"-20px"}}>
									User History
						</h4>
						<MediaSlider header="User history"
							slideTo={this.state.slideToIndex} 
							selection="history" elements={this.state.historyElements} onElementClick={(item)=>{this.selectedPopular(item.id, false)}}/>
					</section>
					
					</article>
        </div>
    );
  }
  
  async componentDidMount() {
	const res = await this.callApi();
	// movie_info returns null for any id it has no imdb_v2 row for (e.g. a
	// popular-list movie CODEX has metadata for but that never got a doc2vec
	// vector) - without filtering those out, `m.genres.join` below throws on
	// the null entry, componentDidMount's promise rejects, setState() never
	// runs, and every section on the page stays empty with no visible error.
	const populareElements = res.filter(m => m).map(m => {
		m.genres = (m.genres || []).join(', ');
		m.selected = false;
		return m;
	});
	this.setState({
		message: "App loaded " + populareElements.length,
		populareElements,
	});
  }

  callApi = async (url) => {
    url = url || ENDPOINTS.popular;
    const response = await fetch(url);
    const body = await response.json();
    if (response.status !== 200) throw Error(body.message);
		let getInfo = function(popular){
				return new Promise((resolve, reject) => {
					fetch(ENDPOINTS.movieInfo + "?id=" + popular.join(','))
						.then(function(response) {
						return response.json();
					})
					.then(function(result) {
						resolve(result.result.items);
					});
		 		});
		}
		return getInfo(body.result.items).then(res => res);
	}
	
	callRecommendationDiversity = async (_ids, splitEq) => {
		if(!_ids) return [];
		splitEq = splitEq === undefined ? true : splitEq;
		let getMatches = function(_ids){
			return Promise.all(_ids.map(_id => {
				return new Promise((resolve, reject) => {
					fetch(ENDPOINTS.similarMovies + "?id=" + _id)
						.then(function(response) {
						return response.json();
					})
					.then(function(result) {
						
						let i = 0;
						let items = result.result.items;
						let len = items.length;
						items = items.filter(r => {
							i++;
							// Add rec_id
							r.push(_id);
							if(splitEq){
								if(Math.ceil(len/_ids.length) >= i){
									return r;
								} else {
									return null;
								}
							} else return r;

						})
						resolve(items);
					});
		 		});
			}));
		}
		let calcBaseArray = [];
		return getMatches(_ids.split(','))
			.then(res => {
			// res is an array of match results
				let _mapper = elements => elements.map(e => {
					//e[0].rec_score = e[1];
					//e[0].rec_id = e[2];
					calcBaseArray.push(e)
					return e;
				});
				for (let i = 0; i < res.length; i++) {
					_mapper(res[i]);
					
				}
				calcBaseArray = calcBaseArray.sort((a, b) => {
					if(a[1] < b[1]){
						return 1;
					}
					if(a[1] > b[1]){
						return -1;
					}
					return 0;
				});
				// remove _ids from results
				calcBaseArray = calcBaseArray.filter(m => {
					if(_ids.indexOf(m[0].id) === -1)
						return m;
					return null;
				});
				return calcBaseArray.slice(0,10);
		});
	}

	callRecommendation = async (_ids, stype) => {
		if(!_ids) return [];
		var alpha = (stype === 'decay') ? '&alpha=' + this.state.decayAlpha : '';
		var _filteredIds = _ids.split(',').filter((value, index, self) => {return self.indexOf(value) === index}).join(',');
		var url = ENDPOINTS.similarMovies + '?id=' + _filteredIds + '&stype='+ stype + alpha;
    	const response = await fetch(url);
    	const body = await response.json();
		if (response.status !== 200) throw Error(body.message);

		return body.result.items;

	}
	removeUserHistory() {
		var _populareElements = (this.state.populareElements).map(m => {m.selected = false; return m;});
		this.setState(Object.assign(this.state, {historyElements: [], mainLaneElements: [], populareElements: _populareElements}));
	}
	
  	selectedPopular = async (id, bool) => { 
		var _state = this.state;
		var _selection = [];
		// update populare or search result
		for(var i=0;i < _state.populareElements.length; i++){
			let selectedMovie = _state.populareElements[i];
			if(selectedMovie.id === id){
				selectedMovie.selected = bool;
			}
			if(selectedMovie.selected){
				_selection.push(selectedMovie.id);
				// push to history
				_state.historyElements.push(selectedMovie);
			}
		}
		if(!bool){
			// remove id from history
			_state.historyElements = _state.historyElements.filter(h => {
				if(h.id === id){
					return null;
				}
				return h;
			});
		}
		let _ids = _state.historyElements.map(m => m.id)
		//var updateMethod = this.state.diversityToggle ? this.callRecommendation : this.callRecommendationDiversity ;
		// var updateMethod = this.callRecommendationDiversity
		var sortType = _state.selectedRecommendation;
		var update = await this.callRecommendation(_ids.join(','), sortType);

		let _getRecInfo = _id => {
			let res = this.state.populareElements.filter(e => {
					if(e.selected && e.id === _id){
						return e;
					}
					return null;
				});
				return res[0];
		};

		let _mainLaneElements = update.map(m => {
			m[0].genres = (m[0].genres || []).join(', ');
			m[0].rec_score = m[1] * 100;
			m[0].rec = m[2]? _getRecInfo(m[2]) : null;
			return m[0];
		})
	
	  // Remove duplicates in recommendations
	  var _historyElements = _state.historyElements;
	  var hflags = {}, _historyElementsNoDulicatedIds = [], hlen = _historyElements.length;
	  for(var h=0;h < hlen; h++){
		  if(hflags[_historyElements[h].id]) continue;
		  hflags[_historyElements[h].id] = true;
		  _historyElementsNoDulicatedIds.push(_historyElements[h]);
	  }
	  _state.historyElements = _historyElementsNoDulicatedIds;
	  // Remove duplicates in history
	  var flags = {}, _mainLaneElementsNoDulicatedIds = [], len = _mainLaneElements.length;
	  for(var ii=0;ii< len; ii++){
		  if(flags[_mainLaneElements[ii].id] || hflags[_mainLaneElements[ii].id]) continue;
		  flags[_mainLaneElements[ii].id] = true;
		  _mainLaneElementsNoDulicatedIds.push(_mainLaneElements[ii]);
	  }
	  _state.mainLaneElements = _mainLaneElementsNoDulicatedIds.splice(0,20);
		let _newState = Object.assign(this.state, _state);
		this.setState(_newState);
	}

	updateDiversityToggle(recType){
		let _newState = Object.assign(this.state, { selectedRecommendation:recType});
		this.setState(_newState);
		this.selectedPopular();
	}
	
	callSearchApi = async (query) => {
		// qtype/neuralsearch was dropped in the migration: the backend now only does
		// CODEX free-text search (no doc2vec model available to infer a query vector).
		var url = ENDPOINTS.search + '?q='+query+'&size=20';
		var start = Date.now();
		const response = await fetch(url);
		const body = await response.json();
		if (response.status !== 200) throw Error(body.message);
		// The endpoint itself no longer reports timing (it returns a bare items
		// list, like every other endpoint) - measured client-side instead, which
		// is arguably more honest anyway (includes real network round-trip).
		return {items: body.result.items, performance: (Date.now() - start) / 1000};

	}

	async searchPopular(query, queryType, flags) {

		var _populareElements = this.state.populareElements;
		if((flags && flags.force === true) || query !== this.state.popularQuery){
			var api = this.callSearchApi;
			// ugly but working
			if(query.replace(/\s+|\t+/gmi).length === 0){ 
				api = this.callApi; 
			}
			const res = await api(query, queryType);
			// Check against historyElements so that we don't present any for userhistory in result.
			var _historyIds = (this.state.historyElements.length  > 0)? this.state.historyElements.map(h => h.id): [];
			// ugly but working
			var _checkarr = res;
			var _performance = 0;
			if(query.replace(/\s+|\t+/gmi).length !== 0){
				_checkarr = res.items;
				_performance = (res.performance * 1000).toFixed(0);
			}
			_populareElements = _checkarr.map(m => {
				if(query === ''){
					let p = [];
					p[0] = m;
					m = p;
				}
				if(_historyIds.length > 0 && _historyIds.indexOf(m[0].id) > -1){
					m[0].selected = true;
				}
				m[0].rec_score = m[1];
				return m[0];
			});
			let _newState = Object.assign(this.state, {popularQuery: query, popularQueryPerformance: _performance,  populareElements: _populareElements, shouldPopularSwiperResetState: !this.state.shouldPopularSwiperResetState});
			this.setState(_newState);
		}
	}

	/* GUI fix */
	showAdv(show){
		this.setState(Object.assign(this.state, {showAdv: show}));
	}
}
export default App;




